<div class="app-content"> 
    <router-outlet></router-outlet> 
    <modulo posicao="whatsapp"></modulo>   
</div>     
